/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import {
    useState, useEffect
} from "react";
//#endregion
//#region Styles
import { Row, Column, SubtitleSection } from "components/styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import HandlerCheckbox, { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import TimeForDays from "./components/TimeForDays/TimeForDays";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion
//#region Utils
import usePrevious from "utils/hooks/usePrevious";
import { DAY_IN_MILLIS } from "components/CustomDatePicker/utils/helpers";
//#endregion

const ManyDaysFields = ({
    changeDuration,
    duration,
    allDays,
    errors,
    hasInactivity = false,
    showInactivitySummaryCard = false,
    ratioMinutesTimeForTimePickers,
    disableControls,
    isCreate,
    hasWaitlist,
    toggleHasWaitlist = () => { },
    isCulturalOrSport,
    isProfessionalTools
}) => {
    const { date, time, days } = duration;
    //#region States
    const [availableDays, setAvailableDays] = useState([]);
    const [startDayId, setStartDayId] = useState(-1);
    const [endDayId, setEndDayId] = useState(-1);
    const [hasWaitlistLocal, setWaitlist] = useState(hasWaitlist);
    const prevAvailableDays = usePrevious(availableDays);
    const [selectAllDays, setSelectAllDays] = useState(false);
    //#endregion
    //#region Effects    
    useEffect(() => {
        if (date.waitlist > 0) {
            setWaitlist(true);
        }
    }, [date.waitlist]);
    useEffect(() => {
        if (availableDays.length < prevAvailableDays?.length) {
            const newDuration = {
                ...duration,
                days: days.filter(currentDayId => availableDays.includes(currentDayId)),
                time: time.filter(currentDay => availableDays.includes(currentDay.dayId))
            };
            changeDuration(
                newDuration, {
                ...errors,
                days: false,
                time: errors.time.filter(currentDay => availableDays.includes(currentDay.dayId))
            });
            setSelectAllDays(true);
        }


    }, [availableDays]);
    useEffect(() => {
        if (days.length === availableDays.length && days.length > 0) {
            setSelectAllDays(true);
            return;
        }
        setSelectAllDays(false);
    }, [duration, availableDays]);
    useEffect(() => {
        if (date.start >= 0 && date.end >= 0) {
            getDatesIn(date.start, date.end);
        }
    }, [date]);
    useEffect(() => {
        toggleHasWaitlist(hasWaitlistLocal);

    }, [hasWaitlistLocal, toggleHasWaitlist])
    useEffect(() => {
        !isCulturalOrSport && isCreate && changeDate("waitlist", -1)
    }, [isCulturalOrSport])
    //#endregion
    //#region Functions
    const changeToggleWaitlist = () => {

        if (isProfessionalTools) {

            setWaitlist(prev => {

                const nextValue = !prev;

                if (!nextValue) {
                    changeDateWaitList("waitlist", -1);
                }

                return nextValue;
            });

        } else {

            setWaitlist(prev => {

                const nextValue = !prev;

                if (!nextValue) {
                    changeDate("waitlist", -1);
                }

                return nextValue;
            });
        }
    };

    const changeDateWaitList = (field, value) => {

        const currentStartDate = date.start;
        const currentEndDate = date.end;
        const currentWaitlist = value;

        const isInvalidWaitlist =
            hasWaitlistLocal &&
            currentWaitlist > 0 &&
            !(
                currentWaitlist > currentStartDate &&
                currentWaitlist < currentEndDate
            );

        changeDuration({
            ...duration,
            date: {
                ...duration.date,
                [field]: value
            }
        }, {
            ...errors,
            date: {
                ...errors.date,
                [field]: false,
                isValidWaitlist: isInvalidWaitlist
            }
        });
    }

    const changeDate = (field, value) => {

        const currentStartDate =
            field === "start" ? value : date.start;

        const currentEndDate =
            field === "end" ? value : date.end;

        const currentWaitlist =
            field === "waitlist"
                ? value
                : date.waitlist;

        const isInvalidWaitlist =
            hasWaitlistLocal &&
            currentWaitlist > 0 &&
            !(
                currentWaitlist > currentStartDate &&
                currentWaitlist < currentEndDate
            );

        setStartDayId(getDayId(currentStartDate));
        setEndDayId(getDayId(currentEndDate));

        changeDuration({
            ...duration,
            date: {
                ...duration.date,
                [field]: value
            }
        }, {
            ...errors,
            date: {
                ...errors.date,
                [field]: false
            },

            areInvalidDates: (
                currentStartDate >= 0 &&
                currentEndDate >= 0 &&
                currentStartDate >= currentEndDate
            ),

            isValidWaitlist: isInvalidWaitlist
        });
    }
    const getDatesIn = (start, end) => {
        const newAvailableDays = [];
        for (let currentDate = start, quantityDays = 0; currentDate <= end; currentDate += DAY_IN_MILLIS, quantityDays++) {
            if (quantityDays >= 7)
                break;
            let dayId = new Date(currentDate).getDay();
            dayId = dayId === 0 ? 7 : dayId;
            if (!newAvailableDays.includes(dayId))
                newAvailableDays.push(dayId);
        }
        setAvailableDays(newAvailableDays);
    }
    const getNewDays = (dayId, add) => {
        return add
            ? [...days, dayId]
            : days.filter(currentDayId => currentDayId !== dayId);
    }
    const getTimeItem = dayId => {
        let newTime = {
            dayId,
            start: -1,
            end: -1
        };
        if (hasInactivity)
            newTime = {
                ...newTime,
                inactivity: []
            };
        return newTime;
    }
    const getErrorTimeItem = dayId => {
        let newErrorTime = {
            dayId,
            start: false,
            end: false,
            areInvalidTimes: false
        };
        if (hasInactivity)
            newErrorTime = {
                ...newErrorTime,
                inactivity: []
            };
        return newErrorTime;
    }
    const getNewTime = (dayId, add) => {
        const { time } = duration;
        return add
            ? [...time, getTimeItem(dayId)]
            : time.filter(currentTime => currentTime.dayId !== dayId);
    }
    const getErrorsTime = (dayId, add) => {
        const { time } = errors;
        return add
            ? [...time, getErrorTimeItem(dayId)]
            : time.filter(currentDay => currentDay.dayId !== dayId);
    }
    const getDayId = (date) => {
        if (date > 0) {
            let dayId = new Date(date).getDay();
            dayId = dayId === 0 ? 7 : dayId;
            return dayId;
        } else {
            return -1;
        }
    }

    const isDayInFormField = value => {
        return duration
            .days.some(
                currentId => currentId === value);
    }
    const handlerDaysField = (dayId) => {
        const add = !(isDayInFormField(dayId));
        changeDuration({
            ...duration,
            days: getNewDays(dayId, add),
            time: getNewTime(dayId, add)
        }, {
            ...errors,
            days: false,
            time: getErrorsTime(dayId, add)
        });
    }
    const handlerChangeSelectAllDays = () => {
        if (selectAllDays) {
            changeDuration({
                ...duration,
                days: [],
                time: []
            }, {
                ...errors,
                days: false,
                time: []
            });
            return;
        }
        const newDays = [];
        const newTime = [...duration.time];
        const newErrorsTime = [...errors.time];
        allDays.forEach(({ id }) => {
            if (availableDays.includes(id))
                newDays.push(id);
            if (!newTime.some(item => item.dayId === id)
                && availableDays.includes(id))
                newTime.push(getTimeItem(id));
            if (!newErrorsTime.some(item => item.dayId === id)
                && availableDays.includes(id))
                newErrorsTime.push(getErrorTimeItem(id));
        });
        changeDuration({
            ...duration,
            days: newDays,
            time: newTime
        }, {
            ...errors,
            days: false,
            time: newErrorsTime
        });
        // if (days.length < availableDays.length)
        //     setSelectAllDays(prev => !prev);
    }
    const handlerChangeTimeForDays = time => {
        changeDuration({
            ...duration,
            time: time.form
        }, {
            ...errors,
            time: time.errors
        });
    }
    //#endregion
    const selectedAnyDays = date.start <= -1 && date.end <= -1;
    return (
        <Column gap="30px">
            <Column>
                <SubtitleSection>Fecha:</SubtitleSection>
                <Row className="flex-start" gap="30px">
                    <CustomDatePicker
                        label="Inicio:"
                        value={date.start}
                        onChange={value => changeDate("start", value)}
                        disabled={disableControls}
                        error={errors.date.start}
                        errorText="Es necesario seleccionar una fecha de inicio." />
                    <CustomDatePicker
                        label="Fin:"
                        value={date.end}
                        onChange={value => changeDate("end", value)}
                        disabled={disableControls}
                        error={errors.date.end}
                        errorText="Es necesario seleccionar una fecha de fin." />
                </Row>
                <ErrorMessage
                    error={errors.areInvalidDates}
                    text="Las fechas son iguales o la fecha de inicio es mayor a la de fin." />
            </Column>
            <Column>
                <SubtitleSection>Días:</SubtitleSection>
                <Row className="flex-start">
                    <HandlerCheckbox
                        checkboxProps={
                            allDays.map(({
                                id, name
                            }) => ({
                                value: id,
                                label: name,
                                disabled: (
                                    disableControls ||
                                    selectedAnyDays ||
                                    !availableDays.includes(id)
                                    //id ==  startDayId || id ==  endDayId
                                ),
                                checked: (isDayInFormField(id)
                                    //id == startDayId || id == endDayId
                                )
                            }))
                        }
                        variant="square"
                        onChange={(id) => (id > 0) && handlerDaysField(id)}
                        error={errors.days}
                        start={date.start}
                        end={date.end}
                        startId={startDayId}
                        endId={endDayId}
                        isCreate={isCreate}
                        errorText="Es necesario que selecciones los días de tu evento." />
                    <CustomCheckbox
                        label="Todos los días"
                        disabled={disableControls || selectedAnyDays}
                        checked={selectAllDays}
                        error={errors.days}
                        onChange={handlerChangeSelectAllDays} />
                </Row>
                <ErrorMessage
                    error={errors.isValidDaysCheckbox}
                    //error={true}
                    text="Los días de la fecha inicio y fin, deben estar seleccionados" />
            </Column>
            <Column>
                <SubtitleSection>Horas:</SubtitleSection>
                {time.length === 0
                    ? <NotificationNoContent
                        title="Aún no has elegido los días"
                        description="Selecciona los días que desees para que puedas definir sus horarios" />
                    : <TimeForDays
                        handlerChange={handlerChangeTimeForDays}
                        allDays={allDays}
                        duration={duration}
                        errors={errors.time}
                        disableControlsForNoLongerDraft={disableControls}
                        showInactivitySummaryCard={showInactivitySummaryCard}
                        ratioMinutesTimeForTimePickers={ratioMinutesTimeForTimePickers} />}
            </Column>
            {
                isProfessionalTools
                    ? <Column>
                        {!disableControls && (
                            <CustomCheckbox
                                label="Configurar lista de espera"
                                variant="switch"
                                disabled={disableControls}
                                checked={hasWaitlistLocal}
                                onChange={changeToggleWaitlist}
                            />
                        )}
                        {(hasWaitlistLocal || date.waitlist > 0) && (
                            <Column>
                                <CustomDatePicker
                                    label="Fecha límite en la cual se visualizará la opción de lista de espera:"
                                    value={date.waitlist}
                                    disabled={true}
                                    error={errors.date.waitlist}
                                    errorText="Es necesario seleccionar una fecha limite de lista de espera." />
                                <ErrorMessage
                                    error={errors.isValidWaitlist}
                                    text="La fecha límite de lista de espera debe estar entre la fecha inicio y fin del evento" />
                            </Column>
                        )}
                    </Column>
                    : <Column>
                        {date.start > 0 && date.end > 0 && isCulturalOrSport && !disableControls && (
                            <CustomCheckbox
                                label="Configurar lista de espera"
                                variant="switch"
                                disabled={disableControls}
                                checked={hasWaitlistLocal}
                                onChange={changeToggleWaitlist}
                            />
                        )}
                        {(hasWaitlistLocal || date.waitlist > 0) && isCulturalOrSport && (
                            <Column>
                                <CustomDatePicker
                                    label="Fecha límite en la cual se visualizará la opción de lista de espera:"
                                    value={date.waitlist}
                                    onChange={value => changeDateWaitList("waitlist", value)}
                                    disabled={false}
                                    error={errors.date.waitlist}
                                    errorText="Es necesario seleccionar una fecha limite de lista de espera." />

                                <ErrorMessage
                                    error={errors.date.isValidWaitlist}
                                    text="La fecha límite de lista de espera debe estar entre la fecha inicio y fin del evento" />
                            </Column>
                        )}
                    </Column>
            }

        </Column>
    );
}

export default ManyDaysFields;
